import { render, staticRenderFns } from "./PrefixMappings.vue?vue&type=template&id=90e77744"
import script from "./PrefixMappings.vue?vue&type=script&lang=js"
export * from "./PrefixMappings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports